<template>
  <div class="previous">
    <el-badge  style="height: 80px;margin-top: 55px" value="hot" >
      <span style="margin: 0;font-size: 38px">往期会议</span>
      <el-divider></el-divider>
    </el-badge>
    <el-row>
      <el-col :offset="2" :span="20" style="height: 500px;margin-top: 45px">
        <ul>
          <li class="one active" @mouseenter="changeActive($event)">
            <div class="item">
              <div class="black">
                <i class="el-icon-edit-outline"></i>
                <p>学术年会</p>
              </div>
            </div>
            <div class="open">
              <el-row style="margin-top: 35px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 25px;">
                <el-col :span="6" style="height:80px ">
                  <i class="el-icon-edit-outline" style="position: absolute;left: 25px;top: -135px;font-size: 26px"><span style="font-size: 22px">学术年会</span></i>
                </el-col>
                <el-col :offset="10" :span="6" style="height:80px;">
                  <el-button style="width: 120px;font-size: 12px;height: 35px;margin-top: 30px;" type="info" @click="toMore" round><span style="position: relative;;top: -170px;color:  white">更多信息</span><i style="position: relative;top: -170px;font-size: 14px" class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-col>
              </el-row>
            </div>
          </li>
          <li class="two" @mouseenter="changeActive($event)">
            <div class="item">
              <div class="black">
                <i class="el-icon-chat-dot-square"></i>
                <p>期刊论坛</p>
              </div>
            </div>
            <div class="open">
              <el-row style="margin-top: 35px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 25px;">
                <el-col :span="6" style="height:80px ">
                  <i class="el-icon-chat-dot-square" style="position: absolute;left: 25px;top: -135px;font-size: 26px"><span style="font-size: 22px">期刊论坛</span></i>
                </el-col>
                <el-col :offset="10" :span="6" style="height:80px;">
                  <el-button style="width: 120px;font-size: 12px;height: 35px;margin-top: 30px;" type="info" @click="toMore" round><span style="position: relative;;top: -170px;color:  white">更多信息</span><i style="position: relative;top: -170px;font-size: 14px" class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-col>
              </el-row>
            </div>
          </li>
          <li class="three" @mouseenter="changeActive($event)">
            <div class="item">
              <div class="black">
                <i class="el-icon-office-building"></i>
                <p>学会会议</p>
              </div>
<!--              <div class="open"></div>-->
            </div>
            <div class="open">
              <el-row style="margin-top: 35px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 25px;">
                <el-col :span="6" style="height:80px ">
                  <i class="el-icon-office-building" style="position: absolute;left: 25px;top: -135px;font-size: 26px"><span style="font-size: 22px">学会会议</span></i>
                </el-col>
                <el-col :offset="10" :span="6" style="height:80px;">
                  <el-button style="width: 120px;font-size: 12px;height: 35px;margin-top: 30px;" type="info" round @click="toMore"><span style="position: relative;;top: -170px;color:  white">更多信息</span><i style="position: relative;top: -170px;font-size: 14px" class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-col>
              </el-row>
            </div>

          </li>
          <li class="four" @mouseenter="changeActive($event)">
            <div class="item">
              <div class="black">
                <i class="el-icon-chat-dot-round"></i>
                <p>其他会议</p>
              </div>
            </div>
            <div class="open">
              <el-row style="margin-top: 35px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :span="6" style="height: 120px;">
                  <div style="width: 180px;height: 120px;background: black;margin-left: 25px"></div>
                </el-col>
                <el-col :offset="4"  :span="12" style="height: 60px">
                  <span style="line-height: 20px;font-size: 16px;width: 300px;height: 50px;word-break:break-word;">111111111111111111111111111111111111111111111111111</span>
                </el-col>
                <el-col :offset="4"  :span="14" style="height: 60px">
                  <i class="el-icon-location-information" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 250px">123</i>
                  <i class="el-icon-time" style="font-size: 16px;line-height: 60px;position: absolute;top:-110px;left: 380px">123</i>
                </el-col>
              </el-row>
              <el-row style="margin-top: 25px;">
                <el-col :span="6" style="height:80px ">
                  <i class="el-icon-chat-dot-round" style="position: absolute;left: 25px;top: -135px;font-size: 26px"><span style="font-size: 22px">其他会议</span></i>
                </el-col>
                <el-col :offset="10" :span="6" style="height:80px;">
                  <el-button style="width: 120px;font-size: 12px;height: 35px;margin-top: 30px;" type="info" round @click="toMore"><span style="position: relative;;top: -170px;color:  white">更多信息</span><i style="position: relative;top: -170px;font-size: 14px" class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-col>
              </el-row>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "previous",
  props: {},
  data(){
    return{
    }
  },
  methods: {
    changeActive($event) {
      // console.log($event);
      $event.path[1].children[0].className = ''
      $event.path[1].children[1].className = ''
      $event.path[1].children[2].className = ''
      $event.path[1].children[3].className = ''
      $event.currentTarget.className = 'active';
    },

    toMore(){
      // let routeData = this.$router.resolve({ path: '/site04',query:{id:a}});
      window.open('#/more', '_blank');
    }
  }
}
</script>

<style scoped lang="less">
.previous{
  background-color: white;
  color: #333;
  text-align: center;
  //line-height: 800px;
  height: 900px;
}
ul{
  width: 100%;
  height: 100%;
  margin: auto;
}
li{
  height: 100%;
  display: flex;
  float: left;
}
ul li:nth-child(1) .item{
  width: 240px;
  height: 100%;
  background-image: url("../assets/previous_1.png");
  position: relative;
}
ul li:nth-child(2) .item{
  width: 240px;
  height: 100%;
  background-image: url("../assets/previous_2.png");
  position: relative;
}
ul li:nth-child(3) .item{
  width: 240px;
  height: 100%;
  background-image: url("../assets/previous_3.png");
  position: relative;
}
ul li:nth-child(4) .item{
  width: 240px;
  height: 100%;
  background-image: url("../assets/previous_4.png");
  position: relative;
}
ul i{
  font-size: 58px;
  margin-top: 168px;
}
.black{
  cursor: pointer;
  width: 100%;height: 100%;
  background-color: rgba(0,0,0,.5);
  color: #fff;
  opacity: 0.8;
  border-right: 1px solid white;
}
.active .item{
 display: none;
}
.open{
  width: 530px;
  height: 110%;
  background: white;
  position: relative;
  top: -20px;
  z-index: 999;
  display: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.active .open{
  width: 530px;
  height: 110%;
  background: white;
  position: relative;
  top: -20px;
  z-index: 999;
  display: block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
</style>
